export default __webpack_public_path__ + "static/media/standing_back_grip.7a6af22d.svg";